const UPDATE_INTL = 'intl/UPDATE'

export const updateIntl = ({ locale, messages }) => ({
  type: UPDATE_INTL,
  payload: { locale, messages },
})

export default updateIntl
